const workCategoryMasters = [
  {
    workCategoryId: 1,
    workCategory: '回収',
  } as const,
  {
    workCategoryId: 2,
    workCategory: '処分',
  } as const,
  {
    workCategoryId: 3,
    workCategory: '積込',
  } as const,
  {
    workCategoryId: 4,
    workCategory: '保管',
  } as const,
  {
    workCategoryId: 5,
    workCategory: '出発',
  } as const,
  {
    workCategoryId: 6,
    workCategory: '到着',
  } as const,
] as const;
export type WorkCategoryNames =
  (typeof workCategoryMasters)[number]['workCategory'];

/**
 * WorkCategory名からWorkCategoryIDに変換。
 * @param name WorkCategoryNames
 * @returns number | undefined
 */
export const getWorkCategoryIDByName = (
  name: WorkCategoryNames
): number | undefined => {
  return workCategoryMasters.find((wc) => wc.workCategory === name)
    ?.workCategoryId;
};
const isWorkCategoryNames = (name: string): name is WorkCategoryNames => {
  return workCategoryMasters
    .map<string>((wc) => wc.workCategory)
    .includes(name);
};
/**
 * nameに対するWorkCategoryIDを返却。
 * 直行の場合は回収、処分、直行ではない場合は保管、積込とする。
 * @param name string
 * @param goesStraight boolean | null
 * @returns number | undefined
 */
export const mustGetPairedWorkCategoryIDByName = (
  name: string,
  goesStraight?: boolean | null
) => {
  if (!isWorkCategoryNames(name)) {
    throw new Error(`Unknown work category name: ${name}`);
  }
  const isDepartureOrArrival = ['出発', '到着'].includes(name);
  if (
    !isDepartureOrArrival &&
    (goesStraight === null || goesStraight === undefined)
  ) {
    throw new Error(
      'Although workCategory is not departure or arrival, goesStraight is empty'
    );
  }
  switch (name) {
    case '出発':
      return getWorkCategoryIDByName('到着');
    case '到着':
      return getWorkCategoryIDByName('出発');
    case '回収':
      return goesStraight
        ? getWorkCategoryIDByName('処分')
        : getWorkCategoryIDByName('保管');
    case '処分':
      return goesStraight
        ? getWorkCategoryIDByName('回収')
        : getWorkCategoryIDByName('積込');
    case '保管':
      return getWorkCategoryIDByName('回収');
    case '積込':
      return getWorkCategoryIDByName('処分');
  }
};

/**
 * WorkCategory名からWorkCategoryIDに変換。
 * 返却の型がnumber出ない場合、指定したエラーを出力する。
 * @param name WorkCategoryNames
 * @returns number
 */
export function mustGetWorkCateoryIDByName(name: WorkCategoryNames): number {
  const ret = getWorkCategoryIDByName(name);
  if (typeof ret !== 'number')
    throw new Error(`Unknown work category name: ${name}`);
  return ret;
}
